import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IconsService } from 'src/app/shared/services/icons.service';
import { Settlement } from 'src/app/models/settlement.model';
import { Building } from 'src/app/models/building.model';
import { Floor } from 'src/app/models/floor.model';
import { Unit } from 'src/app/models/unit.model';
import { Balance } from 'src/app/models/balance.model';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-index-balances',
  template: `
  <div class="d-flex mb-4 mt-4">
      <div class="flex-fill">
        <h1>Recibos</h1>
      </div>
      <div class="col-md-7 mt-4 text-end">
        
        <!-- button class="btn btn-primary btn-lg rounded-5 ms-3" routerLink="/bills/new">Crear recibo</!-->
      </div>
      <!-- xng-breadcrumb ></!-->
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
        <ul #sidebar app-nav-payments [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill">
        <div class="d-flex">
          <div>            
          </div>
          <div class="flex-fill">
            <!-- button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openFilters()">
              <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
              Filtrar búsqueda
            </button -->
          </div>
          <div class="flex-fill ms-2">
            <!-- input type="text" class="form-control rounded-4 border border-1 border-secondary" placeholder="Buscar recibo" formControlName="search" -->
          </div>
        </div>
        <div class="flex-fill list-group rounded-4 shadow mt-4" >
          <div class="list-group rounded-5 shadow">
            <div class="list-group-item bg-white " *ngIf="balances && balances!.length > 0">
              <table class="table table-sm table-hover table-responsive mt-3">
                <thead>
                  <tr>
                    <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">Unidad</th>
                    <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Condominio</th>
                    <th scope="col" class="text-end bg-zazz align-items-center align-middle text-light py-2">Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-balance
                    [balance]="balance"
                    *ngFor="let balance of balances | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
            </div>
            <div class="list-group-item text-center bg-white py-5" *ngIf="balances&&balances.length==0&&loading">
              <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
              <p class="text-muted">Cargando...</p>
            </div>
            <div class="list-group-item text-center py-5" *ngIf="balances&&balances.length==0&&!loading">
              <img src="/assets/images/empty-state.png" width="240px">
              <p class="text-muted">No se encontraron registros</p>
            </div>
            <div class="list-group-item text-center" >
              <pagination-controls
                (pageChange)="pageChanged($event)"
                previousLabel="Prev."
                nextLabel="Sig."
                screenReaderPaginationLabel="Pagination"
                screenReaderPageLabel="page"                  
              ></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class IndexBalancesComponent implements OnInit {
  loading: boolean = false;
  balances: Balance[] = [];
  meta: any = {};
  profile: any = {};
  permissions: any = {};
  searchBox: FormGroup = new FormGroup({});
  payload: any = {
    page: 1,
    per_page: 100,
    tipo: 0
  };

  searchActive: boolean = false;
  p: number = 1;

  settlements: Settlement[] = [];
  buildings: Building[] = [];
  floors: Floor[] = [];
  units: Unit[] = [];

  currentView: string = 'balances';
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private fb: FormBuilder,
    public icons: IconsService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.utility_id = this.profile ? this.profile.utility_id : 0;
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadBalances(this.payload);
    this.loadSettlements();
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: ['']
    });
  }

  loadBalances(payload: any) {
    this.loading = true;
    this.store.getBalances(payload).subscribe({
      next: (balances: any) => {
        console.log("BALANCES => ", balances);
        this.balances = balances.data;
        this.meta = balances.meta;
        this.p = Number(this.meta?.current_page) || Number(payload.page) || 1;
        this.loading = false; // .set(false);
      },
      error: (err: any) => {
        console.log(err);
        this.loading = false; // .set(false);
      }
    })
  }

  searchBalances(event: any) {
    this.payload.page = 1;
    this.p = 1;
    this.payload.name = this.searchBox.value.search;
    this.loadBalances(this.payload);
  }

  checkRouteUrl() {}

  pageChanged(event: any) {
    this.p = event;
    this.payload.page = event;
    this.loadBalances(this.payload);
  }

  loadSettlements() {
    let settlementPayload: any = {
      page: 1,
      per_page: 300,
      utility_id: this.profile.utility_id
    };
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      this.settlements = data.data;
    });
  }

  /*openFilters() {
    const offcanvasRef = this.offcanvasService.open(FullFilterComponent, {
      position: 'end',
      animation: true,
      backdrop: true,
      keyboard: true,
      scroll: true,
      backdropClass: 'bg-dark',
      panelClass: 'bg-light',
    });

    offcanvasRef.componentInstance.payload = this.payFilterPrefs;
    offcanvasRef.componentInstance.profile = this.profile;
    offcanvasRef.result.then((result: any) => {
      console.log('result => ', result);
      this.payFilterPrefs = result;
      this.payFilterPrefs.all = true;
      this.loadBills(this.payFilterPrefs);
    });
  }*/

  selectSettlement(event: any) {
    let buildingPayload: any = {
      page: 1,
      per_page: 50,
      settlement_id: event.target.value
    };
    
    this.store.getBuildings(buildingPayload).subscribe((data: any) => {
      this.buildings = data.data;
      this.searchActive = true;
    });

    this.store.getBalancesBySettlement(event.target.value, { status: false, state: 0 }).subscribe((data: any) => {
      console.log("WHATEVER => ", data);
      this.balances = data; // .filter((el: any) => el.status == false);
    });
  }

  selectBuilding(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 50,
      building_id: event.target.value
    };
    this.store.getFloors(unitPayload).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.store.getBalancesByBuilding(event.target.value, {  }).subscribe((data: any) => {
      console.log("WHATEVER => ", data);
      this.balances = data.filter((el: any) => el.status == false);
    });
  }

  selectFloor(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 50,
      floor_id: event.target.value
    };
    this.store.getUnits(unitPayload).subscribe((data: any) => {
      this.units = data.data;
      console.log("UNITS => ", data);
    });

    this.store.getBalancesByFloor(event.target.value, { }).subscribe((data: any) => {
      console.log("WHATEVER => ", data);
      this.balances = data.filter((el: any) => el.status == false);
    });
  }

  selectUnit(event: any) {
    this.store.getBalancesByUnit(event.target.value, { }).subscribe((data: any) => {
      this.balances = data;
    });
  }

  clearFilter() {
    this.loadBalances(this.payload);
    this.settlements = [];
    this.loadSettlements();
    this.units = [];
    this.floors = [];
    this.buildings = [];
    this.searchActive = false;
  }

}
